import BgMaxPrice from './BgMaxPrice';
import { mapFinalCalculation, RawFinalCalculation } from './mapFinalCalculation';
import mapProduct, { RawProduct } from './mapProduct';
import Reference from './Reference';

interface RawReference {
	packageSize: number;
	referenceBasketVersion: string;
	historicProductDataViewDate: string | null;
}

interface RawBgMaxPrice {
	finalCalculation: RawFinalCalculation;
	_links: { [key: string]: string };
	products: RawProduct[];
	reference: RawReference;
}

export default function mapBgMaxPrice(bgMaxPrice: RawBgMaxPrice): BgMaxPrice {
	return new BgMaxPrice(
		new Reference(
			bgMaxPrice.reference.packageSize,
			bgMaxPrice.reference.referenceBasketVersion,
			bgMaxPrice.reference.historicProductDataViewDate !== null
				? new Date(bgMaxPrice.reference.historicProductDataViewDate)
				: null
		),
		bgMaxPrice.products.map(mapProduct),
		mapFinalCalculation(bgMaxPrice.finalCalculation),
		bgMaxPrice._links
	);
}
